export const enum EntryMode {
    Create  = 1,
    Edit    = 2,
    Display = 0
}
export interface AccommodationSetEntry {
    id            : number,
    countryId     : number,
    country       : string,
    accommodation : number
}
export interface PutAccommodationSetEntry {
    id            : number,
    countryId     : number,
    accommodation : number,
    mode          : EntryMode
}
export interface AccommodationTable {
    id          : number,
    name        : string,
    description : string,
    accommodationSet : AccommodationSetEntry[]
}
export interface PostAccommodationTable {
    name            : string,
    description     : string,
    accommodationSet: PutAccommodationSetEntry[]
}
export interface PutAccommodationTable {
    id               : number,
    name             : string,
    description      : string,
    accommodationSet : PutAccommodationSetEntry[]
}